<template>
  <div class="user">
    <p-button
      icon
      round
      outline
      size="sm"
      class="sidebar-mini-icon text-center photo"
      style="overflow:hidden; display:inline;"
      v-on:click="openUserSelectModal"
      v-if="!pinnedUser"
    >
      <i class="nc-icon nc-zoom-split" style="overflow:hidden; display:inline;"></i>
    </p-button>
    <p-button
      icon
      outline
      size="sm"
      class="sidebar-mini-icon text-center photo"
      style="overflow:hidden; display:inline;"
      v-on:click="unpinUser"
      v-if="pinnedUser"
    >
      <i class="nc-icon nc-simple-remove" style="overflow:hidden; display:inline;"></i>
    </p-button>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleMenu" href="#">
        <span v-if="!pinnedUser" class="sidebar-normal" style="margin-top:10px" v-on:click="openUserSelectModal">
          Select A User
        </span>
        <span v-if="pinnedUser" style="margin-top:10px">
          {{pinnedUsersName}}
          <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition v-if="pinnedUser">
          <ul class="nav nav-menu" v-show="!isClosed">
            <li>
              <router-link to="/selecteduser/userdashboard">
                <span class="sidebar-mini-icon">DSH</span>
                <span class="sidebar-normal">User Dashboard</span>
              </router-link>
            </li>
            <li>
              <router-link to="/selecteduser/selectedusermanagement">
                <span class="sidebar-mini-icon">ACT</span>
                <span class="sidebar-normal">Account</span>
              </router-link>
            </li>
            <li>
              <router-link to="/selecteduser/progressNotes">
                <span class="sidebar-mini-icon">PGN</span>
                <span class="sidebar-normal">Progress Notes</span>
              </router-link>
            </li>
            <li>
              <router-link to="/selecteduser/printSummaryReport">
                <span class="sidebar-mini-icon">PSR</span>
                <span class="sidebar-normal">Print Summary Report</span>
              </router-link>
            </li>
            <li>
              <router-link to="/selecteduser/assignbadge">
                <span class="sidebar-mini-icon">BDG</span>
                <span class="sidebar-normal">Assign Badge</span>
              </router-link>
            </li>
            <li>
              <router-link to="/selecteduser/eatingplan">
                <span class="sidebar-mini-icon">EAT</span>
                <span class="sidebar-normal">Assign Eating Plan</span>
              </router-link>
            </li>
            <li>
              <router-link to="/selecteduser/messagingplan">
                <span class="sidebar-mini-icon">MSG</span>
                <span class="sidebar-normal">Assign Messaging Plan</span>
             </router-link>
            </li>
            <li>
              <router-link to="/selecteduser/learningmodule">
                <span class="sidebar-mini-icon">LRN</span>
                <span class="sidebar-normal">Assign Learning Module</span>
              </router-link>
            </li>
            <li>
              <a @click="redirectToTelehealth()">
                <span class="sidebar-mini-icon">TEL</span>
                <span class="sidebar-normal">Start Telehealth Call</span>
              </a>
            </li>
            <li>
              <a @click="showClientView()">
                <span class="sidebar-mini-icon">VIEW</span>
                <span class="sidebar-normal">Client View</span>
              </a>
            </li>           
          </ul>
        </collapse-transition>
      </div>
    </div>
    <Dialog 
        :visible.sync="modals.selectUser"
        width="70%"
        :fullscreen="false"
        :center='true'
        top="20vh"
        :modal="true"
        :append-to-body="true"
      >
      <div slot="title" class="d-flex">
        <h6>Select A User</h6>
      </div>
      <UserSearch id="UserMenuSearchField" :dataRetrievalFunction="retrieveUserData" :submitFunction="pinUser" />
    </Dialog>
  </div>
</template>

<script>
import { CollapseTransition } from "vue2-transitions";
import {Dialog} from 'element-ui'
import UserSearch from "@/components/UIComponents/UserSearch.vue";
import selectAUserService from "@/services/selectAUser/selectAUserServices.js";
import {redirectToOldPracticeDashboard, syncDashboards} from "@/util/OldDashboardLink.js";
export default {
  components: {
    CollapseTransition,
    UserSearch,
    Dialog
  },

  computed: {
    pinnedUser() {
      var pinnedUser = this.$store.state.pinnedUser.pinnedUser;
      if (pinnedUser) {
        this.modals.selectUser = false;
      }
      return pinnedUser;
    },
    pinnedUsersName() {
      return this.$store.getters["pinnedUser/getPinnedUsersName"];
    },
  },

  data() {
    return {
      isClosed: false,
      modals: {
        selectUser: false,
      },
    };
  },

  methods: {
    toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    openUserSelectModal() {
      this.modals.selectUser = true;
    },
    pinUser(user) {
      this.$store.commit("pinnedUser/pinUser", user);
      this.$store.dispatch('patientInteractionTimer/startTimer', user)
      syncDashboards()
      this.isClosed = false
      this.$router.push("/selectedUser");
    },
    unpinUser() {
      this.$store.commit("pinnedUser/clearUser");
      this.$store.dispatch("patientInteractionTimer/recordAction", "unpin")
      this.isClosed = false
      if (this.$route.matched[0].path == "/selecteduser") {
        this.$router.push("/");
      }
    },
    retrieveUserData(input) {
      // last value is "role", which is only used from the User Management area, so is passed as "all" here
      return selectAUserService.GetUsersByPracticeFilteredByInputForLoggedInUser(this.$store.getters["currentUser/getCurrentUsersPractice"], input, this.$store.getters["currentUser/getCurrentUsersLogin"], "all")
    },
    redirectToTelehealth() {
      this.$store.dispatch('patientInteractionTimer/recordAction', 'telehealthCallStarted')
      redirectToOldPracticeDashboard(`../home/telehealth/telehealth.asp?manage=1`, {
        name: "telehealth",
        width: 900,
        height: 900
      })
    },
    showClientView() {    
      this.$store.dispatch('patientInteractionTimer/recordAction', 'clientViewOpened') 
      redirectToOldPracticeDashboard(`../method_sph_coach/CLIENT_VIEW.ASP`)
    },
  },
};
</script>

<style scoped>
.nav.nav-menu {
  margin-top: 0;
}
</style>

<style>
#UserMenuSearchField .UserDeleteButton {
  display:none;
}
</style>
